import MessagesService from '@/services/messages.service';

const initialState = { all: [] };

export const messages = {
  namespaced: true,
  state: initialState,
  actions: {
    getAll({ commit }) {
      return MessagesService.getAll().then(
        result => {
          commit('messages', result.messages);
          return Promise.resolve(result);
        },
        error => {
          commit('messages', []);
          return Promise.reject(error);
        }
      )
    },
  },
  mutations: {
    messages(state, messages) {
      state.all = messages;
    },
  }
};
